<template>
  <div class="drama-page">
    <!-- Banner区域 -->
    <div class="banner">
      <div class="banner-content">
        <div class="banner-text">
          <h1 class="title">短剧资源</h1>
          <p class="subtitle">精彩短剧，触手可及</p>
        </div>
<!--        <div class="search-container">
          <div class="search-box">
            <el-input
              v-model="searchText"
              placeholder="搜索短剧"
              class="search-input"
              :prefix-icon="Search"
            >
              <template #append>
                <el-button type="primary" @click="search">搜索</el-button>
              </template>
            </el-input>
          </div>
        </div>-->
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="container">
      <div class="content-header">
        <h3>全网短剧实时更新</h3>
        <p class="subtitle-text">
          由于页面显示有限，仅展示最新的100条内容，获取更多资源请点击
          <span class="mini-program-link" @click="showQrCode">小程序</span>
          获取。
        </p>
      </div>

      <!-- 短剧列表 -->
      <div class="drama-list">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="8" :lg="6" v-for="(item, index) in items" :key="index">
            <el-card class="drama-card" :body-style="{ padding: '0px' }">
              <div class="drama-info">
                <h3 class="drama-title">{{ item.name }}</h3>
                <div class="drama-link">
                  <a :href="item.content" target="_blank" rel="noopener">获取链接</a>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 添加小程序码弹窗 -->
    <el-dialog
      v-model="qrCodeVisible"
      title="扫码使用小程序"
      width="300px"
      center
      align-center
    >
      <div class="qr-code-container">
        <img src="/assets/gh_4528a3894a47_344.jpg" alt="小程序码" class="qr-code-image">
        <p>扫描二维码使用小程序</p>
      </div>
    </el-dialog>

    <!-- 页脚 -->
<!--    <footer class="footer">-->
<!--      <p>声明：本站是网盘资源分享平台,所有内容均来源于网络资源，对其内容不负任何责任，若有问题，请联系我们。</p>-->
<!--      <p>QQ：1158622356</p>-->
<!--      <p>&copy; 2024 夸克网盘 | 短剧资源分享平台</p>-->
<!--    </footer>-->
  </div>
</template>

<script>
import { ref } from 'vue'
import { Search } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import { useRoute } from 'vue-router'
export default {
  name: 'HelloWorld',
  setup() {
    const route = useRoute()
    const searchText = ref('')
    const items = ref([])
    const qrCodeVisible = ref(false)

    const showQrCode = () => {
      qrCodeVisible.value = true
    }

    return {
      searchText,
      items,
      Search,
      qrCodeVisible,
      showQrCode
    }
  },
  created() {
     // 检查 URL 参数
    const keyword = this.$route.query.keyword
    if (keyword) {
      this.searchText = keyword
      this.search()
    } else {
      this.fetchData()
    }
  },
  methods: {
    async search() {
      if (!this.searchText) {
        ElMessage.error('请输入搜索关键词')
        return
      }

      try {
        const response = await this.$httpRequest.post('/web/search', {
          keyword: this.searchText
        })
        this.items = response.data

        // 添加搜索结果为空的判断
        if (!this.items || this.items.length === 0) {
          ElMessage({
            message: '未找到相关内容，请尝试其他关键词',
            type: 'warning'
          })
          // 重新加载默认数据
          await this.fetchData()
          // 清空搜索框
          this.searchText = ''
          // 更新 URL，移除 keyword 参数
          this.$router.replace({ query: {} })
        }
      } catch (error) {
        console.error('请求失败:', error)
        ElMessage.error('搜索失败，请稍后再试')
      }
    },
    async fetchData() {
      try {
        const response = await this.$httpRequest.post('/web/queryName')
        this.items = response.data
      } catch (error) {
        console.error("请求失败", error)
      }
    }
  }
}
</script>

<style scoped>
.drama-page {
  min-height: 100vh;
}

.banner {
  height: 300px;
  background-image: linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url('https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?ixlib=rb-4.0.3');
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -60px;
}
.banner-content {
  text-align: center;
  color: white;
  padding-top: 60px;
}

.title {
  font-size: 48px;
  margin: 10px 0; /* 调整上下间距 */
  padding-top: 30px;
  font-weight: 600; /* 加粗标题 */
}
.subtitle {
  font-size: 24px;
  opacity: 0.9; /* 稍微降低透明度 */
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
}

.content-header {
  text-align: center;
  margin: 40px 0;
}

.content-header h3 {
  font-size: 24px;
  color: #333;
  margin-bottom: 12px;
}

.subtitle-text {
  color: #666;
  font-size: 14px;
}

.drama-list {
  margin-bottom: 40px;
}

.drama-card {
  margin-bottom: 20px;
  transition: all 0.3s;
  cursor: pointer;
}

.drama-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.drama-info {
  padding: 20px;
}

.drama-title {
  margin: 0 0 16px 0;
  font-size: 16px;
  color: #333;
  line-height: 1.4;
}

.drama-link a {
  color: #1890ff;
  text-decoration: none;
  font-size: 14px;
}

.drama-link a:hover {
  color: #40a9ff;
  text-decoration: underline;
}

.footer {
  background: #f5f5f5;
  padding: 40px 20px;
  text-align: center;
  color: #666;
  margin-top: 60px;
}

.footer p {
  margin: 8px 0;
  font-size: 14px;
}

:deep(.el-input__wrapper) {
  border-radius: 8px 0 0 8px !important;
}

:deep(.el-input-group__append) {
  border-radius: 0 8px 8px 0 !important;
}

@media (max-width: 768px) {
  .search-container {
    width: 90%;
  }

  .banner {
    height: 300px;
  }

  .title {
    font-size: 32px;
  }

  .subtitle {
    font-size: 18px;
  }
}

.mini-program-link {
  color: #409EFF;
  font-weight: bold;
  cursor: pointer;
  text-decoration: underline;
  transition: color 0.3s;
}

.mini-program-link:hover {
  color: #66b1ff;
}

.qr-code-container {
  text-align: center;
  padding: 20px;
}

.qr-code-image {
  width: 200px;
  height: 200px;
  object-fit: cover;
  margin-bottom: 15px;
}

:deep(.el-dialog) {
  border-radius: 8px;
}

:deep(.el-dialog__header) {
  margin-right: 0;
  text-align: center;
  font-weight: bold;
}
</style>
